import { adapi } from '~';

const SET_INTERESTS = 'SET_INTERESTS';
const SET_LOADING = 'SET_LOADING';

const getters = {
  interests(state) {
    return state.interests || [];
  },
};

const actions = {
  getInterests({ commit }) {
    commit(SET_LOADING, true);
    return adapi.get('resources/interests', { trashed: 1 })
      .then(result => {
        commit(SET_INTERESTS, { interests: result, error: null });
        commit(SET_LOADING, false);
      })
      .catch(error => {
        commit(SET_INTERESTS, { interests: [], error });
        commit(SET_LOADING, false);
      });
  },
};

const mutations = {
  [SET_INTERESTS](state, { interests, error }) {
    state.interests = interests;
    state.error = error;
  },
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
};

export default {
  namespaced: true,
  state: {
    interests: [],
    error: null,
    loading: false,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/interests.js